import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { DemoProvider } from "@/contexts/DemoContext";
import { BackgroundAudioProvider } from "@/contexts/BackgroundAudioContext";
import { CategoryThemeProvider } from "@/contexts/CategoryThemeContext";
import { JobTrackerProvider } from "@/contexts/JobTrackerContext";
import { Toaster } from "@/components/ui/toaster";
import ErrorBoundary from "@/components/ErrorBoundary";
import CleanApp from "./CleanApp.tsx";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
        <ThemeProvider defaultTheme="system">
        <AuthProvider>
          <DemoProvider>
            <BackgroundAudioProvider>
              <CategoryThemeProvider>
                <JobTrackerProvider>
                  <ErrorBoundary>
                    <CleanApp />
                    <Toaster />
                  </ErrorBoundary>
                </JobTrackerProvider>
              </CategoryThemeProvider>
            </BackgroundAudioProvider>
          </DemoProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
